// extracted by mini-css-extract-plugin
module.exports = {"heading":"RelatedPosts-styles-module--heading--28a40","related":"RelatedPosts-styles-module--related--28FQ1"};